import {cs}                                 from "@Common/react/chain-services";
import {consumeContext, provideContext1}    from "@Common/react/context";
import {BraintreeIntegration}               from "@Common/ui-components/braintree/braintree-integration";

export const loadBraintree = ({next}) => cs(
    consumeContext("session"),
    ["braintree", ({session: {tabGuard: {onTabBlur, onTabFocus}}}, next) => BraintreeIntegration({
        defaultStyle: {
            input: {
                "font-size": "14px",
                'color': '#445870',
                'font-weight': 'lighter',
            },
        },
        next: ({renderForm, ...braintree}) => next({
            renderForm: ({next, ...renderFormArgs}) => renderForm({
                next: ({initFields, ...renderFormNext}) => next({
                    initFields: ({hostedFieldsRef, ...initFieldsArgs}) => initFields({
                        hostedFieldsRef: (hostedFields) =>
                        {
                            hostedFields.on("focus", () => onTabFocus?.("braintree"));
                            hostedFields.on("blur", () => onTabBlur?.("braintree"));
                            hostedFieldsRef?.(hostedFields);
                        },
                        ...initFieldsArgs,
                    }),
                    ...renderFormNext,
                }),
                ...renderFormArgs,
            }),
            ...braintree,
        }),
    })],
    ({braintree}) => provideContext1("braintree", braintree, next),
);
